/**
 * Created by Elad_Swissa on 7/19/15.
 */
export var ItemType;
(function (ItemType) {
    ItemType[ItemType["CATEGORY"] = 2] = "CATEGORY";
    ItemType[ItemType["PAGE_CONTENT"] = 5] = "PAGE_CONTENT";
    ItemType[ItemType["SEO_CONTENT"] = 6] = "SEO_CONTENT";
    ItemType[ItemType["TENANT"] = 7] = "TENANT";
    ItemType[ItemType["TICKET"] = 8] = "TICKET";
    ItemType[ItemType["REPLY"] = 9] = "REPLY";
    ItemType[ItemType["ARTICLE"] = 10] = "ARTICLE";
    ItemType[ItemType["NOTIFICATION_TEMPLATE"] = 12] = "NOTIFICATION_TEMPLATE";
    ItemType[ItemType["EMAIL_TEMPLATE"] = 14] = "EMAIL_TEMPLATE";
    ItemType[ItemType["CONTENT_TASK"] = 40] = "CONTENT_TASK";
    ItemType[ItemType["MAILBOX"] = 50] = "MAILBOX";
    ItemType[ItemType["USER"] = 60] = "USER";
    ItemType[ItemType["SAVED_REPLY"] = 70] = "SAVED_REPLY";
    ItemType[ItemType["CATEGORY_INFO"] = 80] = "CATEGORY_INFO";
    ItemType[ItemType["LABEL"] = 90] = "LABEL";
    ItemType[ItemType["CUSTOM_TEXT"] = 100] = "CUSTOM_TEXT";
    ItemType[ItemType["URL_MAPPING"] = 110] = "URL_MAPPING";
    ItemType[ItemType["MULTILINGUAL_TEXT"] = 120] = "MULTILINGUAL_TEXT";
    ItemType[ItemType["HELP_CENTER_CUSTOM_KEYS"] = 121] = "HELP_CENTER_CUSTOM_KEYS";
    ItemType[ItemType["SAVED_FILTER"] = 130] = "SAVED_FILTER";
    ItemType[ItemType["HELP_CENTER_RENDERABLE_COMPONENT"] = 140] = "HELP_CENTER_RENDERABLE_COMPONENT";
    ItemType[ItemType["PHONE_CALL"] = 150] = "PHONE_CALL";
    ItemType[ItemType["NOTE"] = 160] = "NOTE";
    ItemType[ItemType["CHAT_MESSAGE"] = 170] = "CHAT_MESSAGE";
    ItemType[ItemType["CHAT"] = 175] = "CHAT";
    ItemType[ItemType["INTEGRATION"] = 180] = "INTEGRATION";
    ItemType[ItemType["SLA_POLICY"] = 190] = "SLA_POLICY";
    ItemType[ItemType["GROUP"] = 200] = "GROUP";
    ItemType[ItemType["WIDGET"] = 210] = "WIDGET";
    ItemType[ItemType["LINE"] = 220] = "LINE";
    ItemType[ItemType["WIDGET_MULTILINGUAL_TEXTS"] = 221] = "WIDGET_MULTILINGUAL_TEXTS";
    ItemType[ItemType["COMPANY"] = 230] = "COMPANY";
    ItemType[ItemType["HELP_CENTER_STRUCTURE_AND_CONTENT"] = 240] = "HELP_CENTER_STRUCTURE_AND_CONTENT";
    ItemType[ItemType["BRANDING"] = 250] = "BRANDING";
    ItemType[ItemType["QUEUE"] = 260] = "QUEUE";
    ItemType[ItemType["API_KEY"] = 270] = "API_KEY";
    ItemType[ItemType["USER_ROLE"] = 280] = "USER_ROLE";
    ItemType[ItemType["AGENT"] = 300] = "AGENT";
    ItemType[ItemType["WHATSAPP_TEMPLATE"] = 310] = "WHATSAPP_TEMPLATE";
    ItemType[ItemType["CSAT"] = 320] = "CSAT";
    ItemType[ItemType["CSAT_CONTENT"] = 330] = "CSAT_CONTENT";
    ItemType[ItemType["RECIPE"] = 340] = "RECIPE";
    ItemType[ItemType["BRAND"] = 350] = "BRAND";
    ItemType[ItemType["CUSTOM_FIELD"] = 360] = "CUSTOM_FIELD";
    ItemType[ItemType["SCHEDULE"] = 370] = "SCHEDULE";
    ItemType[ItemType["RULE"] = 380] = "RULE";
})(ItemType || (ItemType = {}));
//# sourceMappingURL=item-type.enum.js.map